<template>
  <div>
    <el-drawer ref="drawer" :custom-class="'drawer-self'" title="查看" :visible="true" :direction="'ttb'" size="100vh" @close="cancelDrawer">
      <el-form :model="formData" class="form">
        <div class="drawerLeft">
          <div class="drawerLeftTop">
            <div class="formItem">
              <el-form-item label="工单号" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.work_sn" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="游戏账号" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.account"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="游戏名称" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.game_name"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="游戏服" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.server"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="游戏角色名称" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.game_role_name"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="角色ID" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.game_role_id"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="联系方式" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.tel_num"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="问题类型" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-select v-model="formData.type_id" filterable placeholder="问题类型">
                    <el-option v-for="item in typeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="处理人" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-select v-model="formData.deal_user_id" filterable placeholder="处理人" :disabled="idDisabled">
                    <el-option v-for="item in dealData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="来源" :label-width="formCheckWidth">
                <el-col :span="20">
                  <p v-if="formData.from == 1">人工</p>
                  <p v-if="formData.from == 2">自助</p>
                </el-col>
              </el-form-item>
              <el-form-item label="工单状态" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-select v-model="formData.status" filterable placeholder="状态" :disabled="idDisabled">
                    <el-option v-for="item in statusData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="举报对象角色名" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.report_name" :disabled="formData.report_name == null ? true : false"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="投诉/表扬客服昵称" :label-width="formCheckWidth">
                <el-col :span="20">
                  <el-input v-model="formData.customer_name" :disabled="formData.customer_name == null ? true : false"></el-input>
                </el-col>
              </el-form-item>
            </div>
            <div class="textBox">
              <el-form-item label="详情" :label-width="'40px'">
                <el-col :span="24">
                  <el-input type="textarea" v-model="formData.details" :rows="6"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="备注" :label-width="'40px'">
                <el-col :span="24">
                  <el-input type="textarea" v-model="formData.remarks" :rows="6" @blur="updataRemark"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item class="picBox" label="图片" :label-width="'40px'">
                <el-upload
                  v-model="formData.enclosure"
                  :action="apiUrl"
                  drag
                  multiple
                  list-type="picture-card"
                  :file-list="getStableImageFileList('enclosure', files)"
                  :headers="file_headers"
                  :on-preview="handlePreview"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove"
                  :on-change="handleUploadChange"
                  :on-error="handleUploadError"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogImageVisible">
                  <img style="z-index: 2099" width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
                <span v-if="!pic_status" style="color: red">工单图片异常，建议联系玩家确认</span>
              </el-form-item>
            </div>
          </div>

          <el-table class="leftTable" :border="true" :data="tableLogData" v-if="formData.id != ''">
            <el-table-column prop="work_date" label="时间" />
            <el-table-column prop="work_sn" label="工单号" />
            <el-table-column prop="operation" label="操作" />
            <el-table-column prop="content" :show-overflow-tooltip="true" label="内容" />
            <el-table-column prop="files" width="150px" label="图片">
              <template slot-scope="scope">
                <el-image v-for="item in scope.row.files" :key="item.index" :src="item" style="width: 50px; height: 50px; margin-right: 5px" :preview-src-list="scope.row.files"> </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="deal_user" label="操作人" />
          </el-table>
        </div>
      </el-form>
      <div class="drawerFooter">
        <div class="drawerFooterBtn">
          <el-button @click="cancelDrawer">取消</el-button>
          <el-button type="primary" @click="handleCreateUpdateStore" v-if="formData.id == ''">确 定</el-button>
          <el-button type="primary" @click="handleCreateUpdateStore" v-if="formData.from == 1">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getWorkSnDetail, handleCreateStoreApi, handleLogDataApi, handleGetSelectApi, addAdminRemark } from '@/api/work_sn.js';
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { appendImageInSelectionOrder, imageUploadMixin, normalizeImageList, removeImageByUploadFile } from '@/utils/imageUpload.js';
export default {
  mixins: [imageUploadMixin],
  props: {
    workId: {
      type: [Number, String],
      default: ''
    },
    work_sn: {
      type: [Number, String],
      default: ''
    },
  },
  data() {
    return {
      formData: {},
      tableLogData: [],
      typeData: [],
      dealData: [],
      statusData: [],
      degreeData: [
        { id: 1, name: '满意' },
        { id: 2, name: '一般' },
        { id: 3, name: '不满意' },
      ],
      formLabelWidth: '120px',
      formCheckWidth: '130px',
      formInputWidth: '200px',
      idDisabled: true,
      apiUrl: BASE_API + 'admin/work_upload_admin',
      files: [],
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken(),
      },
      dialogImageVisible: false,
      dialogImageUrl: '',
      // 图片状态判断
      pic_status: true,
      qualityShow: true,
    };
  },
  created() {
    this.getWorkSnDetail()
    this.getLogData()
    this.getSelectList()
  },
  methods: {
    async getWorkSnDetail() {
      const r = await getWorkSnDetail(this.workId)
      this.formData = { ...r.data.data }
      this.files = normalizeImageList(this.formData.enclosure, 'worksn-detail')
      this.formData.enclosure = this.files
    },
    async getLogData() {
      const r = await handleLogDataApi({ work_sn: this.work_sn })
      this.tableLogData = r.data.data
    },
    async getSelectList() {
      const r = await handleGetSelectApi()
      this.typeData = r.data.type;
      this.dealData = r.data.user;
      this.statusData = r.data.status;
    },
    // 修改备注
    async updataRemark() {
      const obj = {
        id: this.formData.id,
        admin_remarks: this.formData.remarks,
      };
      const { data } = await addAdminRemark(obj);
      if (data.code !== 1) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('修改备注成功！');
      this.$emit('updated');
    },
    async handleCreateUpdateStore() {
      if (!this.guardImageUploads(['enclosure'])) return;
      const requiredFields = [
        ['account', '请添加游戏账号！'],
        ['game_name', '请添加游戏名！'],
        ['game_role_name', '请添加游戏角色名称！'],
        ['server', '请添加游戏服！'],
      ];
      const missing = requiredFields.find(([field]) => !this.formData[field]);
      if (missing) {
        this.$message.error(missing[1]);
        return;
      }

      const response = await handleCreateStoreApi(this.formData);
      if (response.data.code != 200) {
        this.$message.error(response.data.message);
        return;
      }
      this.$message.success('操作成功');
      this.$emit('updated');
      this.cancelDrawer();
    },
    handleUploadChange(file, fileList) {
      this.trackImageUpload('enclosure', file, fileList);
    },
    handleRemove(file, fileList) {
      this.files = removeImageByUploadFile(this.files, file);
      this.formData.enclosure = this.files;
      this.removeTrackedImage('enclosure', file, fileList);
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },
    handleSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('enclosure', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('enclosure', file, fileList);
        this.$message.error(response.message);
      } else {
        this.files = appendImageInSelectionOrder(this.files, file, { url: response.data.path, name: response.data.name || file.name });
        this.formData.enclosure = this.files;
        this.trackImageUpload('enclosure', file, fileList);
        this.$message.success(response.message);
      }
    },
    handleUploadError(error, file, fileList) {
      if (!this.isCurrentImageUpload('enclosure', file)) return;
      this.trackImageUpload('enclosure', file, fileList);
      this.$message.error(`${file.name || '图片'}上传失败`);
    },
    cancelDrawer() {
      this.resetImageUploadScope('enclosure');
      this.$emit('closeDrawer')
    }
  },
}
</script>

<style scoped>
.drawer-self {
  overflow-y: auto;
  z-index: 1999;
}
.drawerLeft {
  width: 100%;
  /* background-color: lightgreen; */
}
.drawerLeftTop {
  width: 100%;
  display: flex;
}
.form {
  height: auto;
  display: flex;
  margin-left: 30px;
  /* background-color: pink; */
}
.formItem {
  width: 45%;
}
.drawerFooter {
  height: 50px;
  position: relative;
}
.drawerFooterBtn {
  position: absolute;
  right: 50px;
  bottom: 10px;
}
</style>
